import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="ainstein-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>AInstein</h3>
            <p>Your AI-powered learning assistant for better education.</p>
            <div className="social-links">
              <a href="https://twitter.com/pankaj6apr" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://instagram.com/appainstein" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/ainstein/privacy">Privacy Policy</Link></li>
              <li><Link to="/ainstein/terms">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} AInstein. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
